import { defaultColumns, defaultSort } from '../../components/data/cars/columns';

export default {
  state: {
    cars: [],
    tableConfig: null,
    loading: false,
  },
  getters: {
    cars: state => state.cars,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
  },
  mutations: {
    setCars(state, cars) {
      state.cars = cars;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      commit('setLoading', true);
      try {
        const setting = await axios.get('api/table-settings/car-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'car-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'car-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchAll({ commit }, queryString) {
      commit('setLoading', true);
      try {
        const setting = await axios.get('api/table-settings/car-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'car-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'car-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
        const cars = await axios.get('api/cars' + (queryString || ''));
        commit('setCars', cars);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/cars/${id}`);
    },
    async create({ commit }, car) {
      await axios.post('api/cars', car);
    },
    async update({ commit }, car) {
      await axios.put('api/cars', car);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/cars/${id}`);
    },
  },
};
